import { Component, Input, OnChanges } from '@angular/core';
import { EsgConstants } from '@ddt-web/config';
import { InjectConfig, PcConfigKey } from '@ddt-web/config-layer';

import { EsgScoreImpact } from '../models';

@Component({
	selector: 'esg-score-impact',
	templateUrl: './esg-score-impact.component.html',
	styleUrls: ['./esg-score-impact.component.scss']
})
export class EsgScoreImpactComponent implements OnChanges {
	@InjectConfig(PcConfigKey.SHOW_AS_OF_DATE_DYNAMIC) public readonly showAsOfDateDynamic: boolean = EsgConstants.SHOW_AS_OF_DATE_DYNAMIC_DEFAULT;

	@Input() public metricsData: Array<EsgScoreImpact>;
	@Input() public disclosureDcrKey: string;
	@Input() public titleDcrKey: string;
	@Input() public subtitleDcrKey: string;
	@Input() public asOfDate: string;

	public multiPortfolios: boolean = false;
	public columnClass1: string = 'col-10';
	public columnClass2: string = 'col-14';

	public ngOnChanges(): void {
		if (this.metricsData?.length > 1) {
			this.multiPortfolios = true;
			this.getColumnClass();
		}
	}

	private getColumnClass(): void {
		if (this.metricsData?.length < 10) {
			this.columnClass1 = 'col-10';
			this.columnClass2 = 'col-14';
		} else {
			this.columnClass1 = 'col-4';
			this.columnClass2 = 'col-20';
		}
	}
}
